import React, { PureComponent } from 'react';
import { Button } from '@ui-propulsion/react-components';
import PhoneField from './phone-field';
import SelectField from './select-field';
import TextField from './text-field';
import SelectDropdownField from './select-dropdown-field';
import classNames from 'classnames';
import Modal from './modal';
import FillMe from './fill-me';
import Randoms from '../lib/randoms';
import { validNameKey, handleOnPasteForNameField } from '../lib/valid-key';
import enrichUserPropsWithLead from '../lib/enrichUserPropsWithLead';
import Spinner from './spinner';

class Enrollment extends PureComponent {

  state = {
    hasRequestedMoreInfo: false,
    showAdditionalInfoInput: false,
    placeHolder: null,
    disableAction: false
  };

  defaultHowDidYouHearAboutUsValue = 'Select';
  consultant = 'Consultant, lab, vendor or lecture';
  meeting = 'Meeting or tradeshow';

  dropdownValues = [this.consultant,
                    'Print advertisement',
                    'Email or online advertisement',
                    'Direct mail',
                    'Word of mouth or referral',
                    this.meeting,
                    'Web search',
                    'LendingClub Patient Solutions representative',
                    'Other or I don\'t know'];

  handleNameChange = (e) => {
    const {
      actions: { enterPracticeName },
      errors
    } = this.props;

    const { target: { value } } = e;
    const runValidation = errors.practiceName ? true : false;
    enterPracticeName(value, runValidation);
  };

  handleNameBlur = (e) => {
    const { enterPracticeName } = this.props.actions;
    const { target: { value } } = e;
    enterPracticeName(value);
  }

  handleEmailChange = (e) => {
    const {
      actions: { enterPracticeEmail },
      errors
    } = this.props;
    const { target: { value } } = e;
    const runValidation = errors.practiceEmail ? true : false;
    enterPracticeEmail(value, runValidation);
  };

  handleEmailBlur = (e) => {
    const { enterPracticeEmail } = this.props.actions;
    const { target: { value } } = e;
    enterPracticeEmail(value);
  };

  handlePhoneChange = (e) => {
    const { enterPracticePhone } = this.props.actions;
    const { target: { value } } = e;
    enterPracticePhone(value);
  }

  handleTypeChange = (value) => {
    const { selectPracticeType } = this.props.actions;
    selectPracticeType(value);
  }

  handleHowDidYouHearAboutUsChange = (e) => {
    const { target: { value } } = e;
    const { errors } = this.props;
    const runValidation = errors.howDidYouHearAboutUs ? true : false;
    this.executeQuestionaireChoice(value, runValidation);
  }

  handleHowDidYouHearAboutUsBlur = (e) => {
    const { target: { value } } = e;
    this.executeQuestionaireChoice(value);
  }

  executeQuestionaireChoice = (value, executeValidation = true) => {
    let showAdditionalInfoInput = false;
    let placeHolder = null;

    if (value === this.consultant) {
      showAdditionalInfoInput = true;
      placeHolder = 'Enter consultant, lab, vendor or lecture name';
    } else if (value === this.meeting) {
      showAdditionalInfoInput = true;
      placeHolder = 'Enter meeting or tradeshow name';
    }

    this.setState({
      showAdditionalInfoInput,
      placeHolder
    }, () => {
      const { selectHowDidYouHearAboutUs } = this.props.actions;
      selectHowDidYouHearAboutUs(value, this.defaultHowDidYouHearAboutUsValue, executeValidation);
    });
  }

  handleAdditionalInfoChange = (e) => {
    const { target: { value } } = e;
    const { enterFieldData } = this.props.actions;
    enterFieldData('additionalInfo', value, {
      isRequired: false,
      fieldDisplayName: 'Additional Information'
    });
  }

  handleAdditionalInfoBlur = (e) => {
    const { target: { value } } = e;
    const { enterFieldData } = this.props.actions;
    enterFieldData('additionalInfo', value, {
      isRequired: true,
      fieldDisplayName: 'Additional Information'
    });
  }

  handleSubmit = () => {
    const {
      practice,
      actions: { submitPracticeInfo }
    } = this.props;
    const { showAdditionalInfoInput } = this.state;

    this.setState({ disableAction: true }, () => {
      submitPracticeInfo({...practice, showAdditionalInfoInput})
        .then((data) => {
          const { capId } = data.practice;
          enrichUserPropsWithLead(capId);
          this.props.history.push('/patientsolutions/enroll/create-account');
        })
        .catch(({ status }) => {
          this.setState({ disableAction: false });
          if (status && status !== 400) {
            window.location.href = '/patientsolutions/enroll/error';
          }
        });
    });
  }

  continue = () => {
    const { history } = this.props;
    this.setState({ hasRequestedMoreInfo: false },
      () => history.push('/patientsolutions/enroll/create-account'));
  }

  handleRequestMoreInfo = (e) => {
    e.preventDefault();
    const { submitPracticeInfo } = this.props.actions;
    submitPracticeInfo(this.props.practice, true)
      .then(({ downloadLink, capId }) => {
        enrichUserPropsWithLead(capId);
        this.setState({ hasRequestedMoreInfo: true }, () => {
          window.open(`/patientsolutions/enroll/get-info/${downloadLink}`, '_blank');
        });
      })
      .catch(({ status }) => {
        if (status && status !== 400) {
          window.location.href = '/patientsolutions/enroll/error';
        }
      });
  }

  handleFillMe = (e) => {
    const {
      enterPracticeName,
      enterPracticeEmail,
      enterPracticePhone,
      selectPracticeType,
      selectHowDidYouHearAboutUs,
      enterFieldData
    } = this.props.actions;
    enterPracticeName(Randoms.randomPracticeName());
    selectPracticeType('Dental');
    enterPracticeEmail(Randoms.randomEmail());
    enterPracticePhone(Randoms.randomPracticePhone());
    this.setState({
      showAdditionalInfoInput: true,
      placeHolder: 'Enter meeting or tradeshow name'
    });
    selectHowDidYouHearAboutUs(this.meeting, this.defaultHowDidYouHearAboutUsValue);
    enterFieldData('additionalInfo', 'Webex Meeting', {
      isRequired: true,
      fieldDisplayName: 'Additional Information'
    });
  }

  hasValidationErrors = () => {
    const { errors } = this.props;
    return errors.practiceName ||
    errors.practiceType ||
    errors.practiceEmail ||
    errors.practicePhone ||
    errors.additionalInfo ||
    errors.howDidYouHearAboutUs;
  }

  componentDidMount() {
    if (window.lcTracking && window.lcTracking.tracking) {
      const data = window.lcTracking.data || { userProps: {} };
      const trackingData = Object.assign(data, {});
      trackingData.userProps.PF_EREG_EXP = 'ALT';
      window.lcTracking.tracking.enrichEventsForUser(trackingData.userProps);
    }
  }

  render() {

    const {
      practice,
      onboarding,
      highlightMoreInfo
    } = this.props;

    const {
      name,
      email,
      phone,
      type,
      howDidYouHearAboutUs,
      additionalInfo
    } = practice;

    const { processingSubmit } = onboarding;
    const { hasRequestedMoreInfo } = this.state;
    const additionalButtonProps = {};

    const moreInfoClasses = classNames('more-info', {
      'more-info--highlighted': highlightMoreInfo
    });

    const disableAction = this.state.disableAction && this.hasValidationErrors();
    if (disableAction) {
      additionalButtonProps.disabled = true;
    }

    const buttonClasses = classNames('button-submit button-submit-next', {
      'button-submit--all-fields': name && email && phone && type,
      'disabled': disableAction
    });

    return <section className="first-section">
      <Modal
        className='enroll-modal'
        showClose={false}
        isOpen={hasRequestedMoreInfo}
        title='Thanks for your interest in a fresh approach to patient financing.'>
        <Button onClick={this.continue} className='confirm-btn'>Continue Enrollment</Button>
      </Modal>
      <h1 className='section-title'>Tell us more about your practice</h1>
      <p>Enrolling is easy and free. Have questions? Give us a call at <a href="tel:1-800-630-1663">(800) 630-1663.</a></p>
      <form>
        <TextField
          data-test-id="practice-name-field"
          aria-required
          onBlur={this.handleNameBlur}
          onChange={this.handleNameChange}
          onKeyDown={validNameKey}
          onPaste={handleOnPasteForNameField}
          errorMsg={this.props.errors.practiceName}
          defaultValue={name}
          className='input-helper'
          htmlFor='practice_name'
          labelText='Practice Name'
          labelClassName='section-label'
          helperTextClassName='section-helper-txt'
          helperText='This name will be displayed when patients look up your practice.'
        />

        <SelectField
          options={[
            { text: 'Dental', value: 'Dental' },
            { text: 'Fertility', value: 'Fertility' },
            { className: 'pill-hair', text: 'Hair Restoration', value: 'Hair Restoration' },
            { text: 'Bariatric', value: 'Bariatric' }
          ]}
          aria-required
          errorMsg={this.props.errors.practiceType}
          className='input-helper-select'
          htmlFor='practice_type'
          labelText='Practice Type'
          labelClassName='section-label'
          onKeyDown={this.handleTypeChange}
          onChange={this.handleTypeChange}
          defaultValue={type}
          selectedValue={type}
        />

        <TextField
          data-test-id="practice-email-field"
          aria-required
          onChange={this.handleEmailChange}
          onBlur={this.handleEmailBlur}
          errorMsg={this.props.errors.practiceEmail}
          className='input-helper'
          htmlFor='practice_email'
          labelText='Primary Contact Email'
          labelClassName='section-label'
          defaultValue={email}
        />

        <PhoneField
          htmlFor='practice_phone'
          inputClassName='txt-field-input'
          labelText='Primary Contact Phone'
          labelClassName='section-label'
          className='input-helper'
          onBlur={this.handlePhoneChange}
          defaultValue={phone}
          errorMsg={this.props.errors.practicePhone}
        />

        <SelectDropdownField
          aria-required
          data-test-id="hdyh-field"
          className='input-helper'
          htmlFor='howDidYouHearAboutUs'
          labelText='How did you hear about us?'
          labelClassName='section-label'
          selectClassName='select-dropdown-field-input'
          errorMsg={this.props.errors.howDidYouHearAboutUs}
          listValues={this.dropdownValues}
          value={howDidYouHearAboutUs}
          defaultInitialValue={this.defaultHowDidYouHearAboutUsValue}
          onChange={this.handleHowDidYouHearAboutUsChange}
          onBlur={this.handleHowDidYouHearAboutUsBlur}
        />

        { this.state.showAdditionalInfoInput
          ? <TextField
              data-test-id="practice-additional-info-field"
              aria-required
              onBlur={this.handleAdditionalInfoBlur}
              onChange={this.handleAdditionalInfoChange}
              onKeyDown={validNameKey}
              onPaste={handleOnPasteForNameField}
              errorMsg={this.props.errors.additionalInfo}
              defaultValue={additionalInfo}
              className='input-helper'
              htmlFor='additional_info'
              placeholder={this.state.placeHolder}
            />
          : null
        }

        <div className='action-area'>
          { !highlightMoreInfo &&
              <Button
                data-test-id="next-step-button"
                {...additionalButtonProps}
                className={buttonClasses}
                onClick={this.handleSubmit}
                aria-label='practice submit button'>
                <span className='button-submit-text'>Next</span>
              </Button>
          }
          <a onClick={this.handleRequestMoreInfo} className={moreInfoClasses}>Request More Information</a>
        </div>

        <FillMe
          handleOnClick={this.handleFillMe}
          env={this.props.env}
        ></FillMe>

        { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }

      </form>
    </section>;
  }
}

export default Enrollment;

